module.exports = __webpack_public_path__ + "media/images/swifticons/weather-partly-cloudy-comment-ceb410e863dfe500eb78a62eb25a6756.svg";